import { useCallback, useEffect, useState } from "react";
import { api, authHeaders, formatApiErrorDetail } from "@/lib/api";

/**
 * useAdminJobs — data layer for the admin dashboard.
 * Handles list + delete against /api/jobs and /api/admin/jobs.
 */
export function useAdminJobs() {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const reload = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const { data } = await api.get("/jobs");
      setJobs(data || []);
    } catch (e) {
      setError(formatApiErrorDetail(e?.response?.data?.detail) || e.message);
    } finally {
      setLoading(false);
    }
    // Only module-level imports are used; setters from useState are stable.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const remove = useCallback(async (id) => {
    await api.delete(`/admin/jobs/${id}`, { headers: authHeaders() });
    await reload();
  }, [reload]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { jobs, loading, error, reload, remove };
}
